// extracted by css-extract-rspack-plugin
export default {"section":"jl8kCRaClqMhKR7d","configGrid":"QE6Am1w80qv6LYEK"};